module.exports = __webpack_public_path__ + "img/logo.9489d733.svg";